var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fieldData.fieldType === "3-30" &&
    _vm.rowData["flowerDesignId"] &&
    (_vm.rowData["issueFlower"] === 0 || _vm.rowData["issueFlower"] === 1)
    ? _c("span", { staticClass: "supplierContacts" }, [
        _c("div", { staticClass: "related-content" }, [
          _c("p", { on: { click: _vm.downloadFile } }, [
            _c(
              "span",
              {
                staticStyle: {
                  color: "#FF8850",
                  "text-decoration": "underline",
                  cursor: "pointer",
                },
              },
              [_vm._v("花稿下载")]
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }